module.exports = __webpack_public_path__ + "img/Flag_of_the_United_Kingdom.8605a7f8.png";